import { ImportarPessoasController } from './view/pessoas/importar-pessoas-controller/importar-pessoas-controller';
import { Routes } from '@angular/router';
import { authGuard } from './guards/auth-guard';
import { recoveryFlowGuard } from './guards/recovery-flow.guard';
import { masterRoleGuard } from './guards/master-role.guard';
import { unsavedChangesGuard } from './guards/unsaved-changes-guard';
// Auth Components
import { Login } from './view/auth/login/login';
import { Callback } from './view/auth/sso/callback/callback';
import { SolicitarCodigo } from './view/auth/recuperar-senha/solicitar-codigo/solicitar-codigo';
import { VerificarEmail } from './view/auth/recuperar-senha/verificar-email/verificar-email';
import { ConfirmarCodigo } from './view/auth/recuperar-senha/confirmar-codigo/confirmar-codigo';
import { LinkExpirado } from './view/auth/recuperar-senha/link-expirado/link-expirado';
import { DefinirSenha } from './view/auth/recuperar-senha/definir-senha/definir-senha';
import { SenhaRedefinidaSucesso } from './view/auth/recuperar-senha/senha-redefinida-sucesso/senha-redefinida-sucesso';
import { ValidarLink } from './view/auth/primeiro-acesso/validar-link/validar-link';
import { LinkLiberado } from './view/auth/primeiro-acesso/validar-link/link-liberado/link-liberado';
import { LinkExpiradoPrimeiroAcesso } from './view/auth/primeiro-acesso/validar-link/link-expirado-primeiro-acesso/link-expirado-primeiro-acesso';
import { PrimeiroAcessoSenhaDefinidaComSucesso } from './view/auth/primeiro-acesso/primeiro-acesso-senha-definida-com-sucesso/primeiro-acesso-senha-definida-com-sucesso';

// App Components
import { Home } from './view/home/home';
import { Notificacoes } from './view/notificacoes/notificacoes';
import { Cindi } from './view/cindi/cindi';
import { Equilibria } from './view/equilibria/equilibria';
import { FaqComponent } from './view/faq/faq.component';
import { Utils } from './components/utils/utils';
import { NotFound } from './view/not-found/not-found';

// Pessoas
import { ListarPessoas } from './view/pessoas/listar-pessoas/listar-pessoas';
import { CadastrarPessoa } from './view/pessoas/cadastrar-pessoa/cadastrar-pessoa';

// Avisos
import { ListarAvisos } from './view/avisos/listar-avisos/listar-avisos';
import { CriarAvisoComponent } from './view/avisos/criar-aviso/criar-aviso.component';
import { DetalhesAviso } from './view/avisos/detalhes-aviso/detalhes-aviso';

// Empresas
import { ListarEmpresas } from './view/empresa/listar-empresas/listar-empresas';
import { CadastrarEmpresa } from './view/empresa/cadastrar-empresa/cadastrar-empresa';
import { CadastrarEndereco } from './view/empresa/cadastrar-empresa/cadastrar-endereco/cadastrar-endereco';
import { UsuariosCadastradosView } from './view/usuarios/usuarios-cadastrados-view/usuarios-cadastrados-view';
import { CadastrarAtualizarUsuarioView } from './view/usuarios/cadastrar-atualizar-usuario-view/cadastrar-atualizar-usuario-view';
import { ListarGrupos } from './view/grupos/listar-grupos/listar-grupos';
import { CadastrarGrupo } from './view/grupos/cadastrar-grupo/cadastrar-grupo';
import { CadastrarGrupoEmpresas } from './view/grupos/cadastrar-grupo/cadastrar-grupo-empresas/cadastrar-grupo-empresas';
import { ListaImportacoesPessoas } from './view/pessoas/lista-importacoes-pessoas/lista-importacoes-pessoas';
import { ExportarDados } from './view/pessoas/exportar-dados/exportar-dados';

// MovIA
import { AnalisePosturalController } from './view/movia/analise-postural-controller/analise-postural-controller';
import { saudeRoleGuard } from './guards/saude-role.guard';
import { saudeOuMasterRoleGuard } from './guards/saude-ou-master-role.guard';
import { GerenciarModulos } from './view/modulos/gerenciar-modulos/gerenciar-modulos';
import { EditarModulo } from './view/modulos/editar-modulo/editar-modulo';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },

  // MARK: Área pública
  {
    path: 'auth',
    children: [
      // Login
      {
        path: 'login',
        component: Login,
        data: { animation: 'Login' },
      },

      // Recuperação de senha
      {
        path: 'recuperar-senha',
        component: SolicitarCodigo,
        data: { animation: 'SolicitarCodigo' },
      },
      {
        path: 'verificar-email',
        component: VerificarEmail,
        data: { animation: 'VerificarEmail' },
      },
      {
        path: 'confirmar-codigo',
        component: ConfirmarCodigo,
        data: { animation: 'ConfirmarCodigo' },
      },
      {
        path: 'link-expirado',
        component: LinkExpirado,
        data: { animation: 'LinkExpirado' },
      },
      {
        path: 'definir-senha',
        component: DefinirSenha,
        data: { animation: 'DefinirSenha' },
      },
      {
        path: 'senha-redefinida-sucesso',
        component: SenhaRedefinidaSucesso,
        data: { animation: 'SenhaRedefinidaSucesso' },
      },

      // Primeiro acesso
      {
        path: 'primeiro-acesso',
        component: ValidarLink,
      },
      {
        path: 'primeiro-acesso/link-expirado',
        component: LinkExpiradoPrimeiroAcesso,
      },
      {
        path: 'primeiro-acesso/link-liberado',
        component: LinkLiberado,
      },
      {
        path: 'primeiro-acesso/definir-senha',
        component: DefinirSenha,
      },
      {
        path: 'primeiro-acesso/senha-definida-sucesso',
        component: PrimeiroAcessoSenhaDefinidaComSucesso,
      },

      // SSO
      {
        path: 'callback',
        component: Callback,
      },
    ],
  },

  // MARK: Área autenticada
  {
    path: '',
    canActivate: [authGuard],
    children: [
      // Principal
      {
        path: 'home',
        component: Home,
        data: { animation: 'Home' },
      },

      // Módulos
      {
        path: 'notificacoes',
        component: Notificacoes,
        data: { animation: 'Notificacoes' },
      },
      {
        path: 'cindi',
        component: Cindi,
        data: { animation: 'Cindi' },
      },
      {
        path: 'equilibria',
        component: Equilibria,
        data: { animation: 'Equilibria' },
      },
      {
        path: 'ajuda-e-suporte',
        component: FaqComponent,
      },

      // Pessoas
      {
        path: 'pessoas',
        canActivate: [authGuard],
        children: [
          {
            path: '',
            component: ListarPessoas,
            data: { animation: 'ListarPessoas' },
            canDeactivate: [unsavedChangesGuard],
          },

          {
            path: 'importar',
            component: ImportarPessoasController,
            data: { animation: 'ImportarPessoa' },
            canDeactivate: [unsavedChangesGuard],
          },

          {
            path: 'importar/nova',
            component: ListaImportacoesPessoas,
            data: { animation: 'ImportarPessoa' },
            canDeactivate: [unsavedChangesGuard],
          },
          {
            path: 'exportar',
            component: ExportarDados,
          },
          {
            path: 'cadastrar',
            component: CadastrarPessoa,
            data: { animation: 'CadastrarPessoa' },
            canDeactivate: [unsavedChangesGuard],
          },
          {
            path: ':id',
            component: CadastrarPessoa,
            data: { animation: 'CadastrarPessoa' },
            canDeactivate: [unsavedChangesGuard],
          },
        ],
      },

      // Avisos
      {
        path: 'avisos',
        canActivate: [authGuard],
        children: [
          {
            path: '',
            component: ListarAvisos,
          },
          {
            path: 'novo',
            component: CriarAvisoComponent,
          },
          {
            path: 'editar/:id',
            component: CriarAvisoComponent,
          },
          {
            path: 'detalhes/:id',
            component: DetalhesAviso,
          },
        ],
      },

      // Empresas
      {
        path: 'empresas',
        canActivate: [authGuard],
        children: [
          {
            path: '',
            component: ListarEmpresas,
          },
          {
            path: 'cadastrar',
            component: CadastrarEmpresa,
          },
          {
            path: ':id',
            component: CadastrarEmpresa,
          },
          {
            path: 'endereco',
            component: CadastrarEndereco,
          },
        ],
      },

      // Usuários
      {
        path: 'usuarios',
        canActivate: [authGuard],
        children: [
          {
            path: '',
            component: UsuariosCadastradosView,
          },
          {
            path: 'cadastrar',
            component: CadastrarAtualizarUsuarioView,
          },
          {
            path: ':id',
            component: CadastrarAtualizarUsuarioView,
          },
        ],
      },
      {
        path: 'grupos',
        children: [
          {
            path: '',
            component: ListarGrupos,
          },
          {
            path: 'cadastrar',
            component: CadastrarGrupo,
            canActivate: [masterRoleGuard],
          },
          {
            path: 'editar/:id',
            component: CadastrarGrupo,
          },
          {
            path: 'cadastrar/empresas',
            component: CadastrarGrupoEmpresas,
            canActivate: [masterRoleGuard],
          },
        ],
      },
      {
        path: 'modulos',
        canActivate: [masterRoleGuard],
        children: [
          {
            path: '',
            component: GerenciarModulos,
          },
          {
            path: ':id/editar',
            component: EditarModulo,
          },
        ],
      },
      {
        path: 'movia/analise-postural',
        canActivate: [authGuard, saudeOuMasterRoleGuard],
        component: AnalisePosturalController,
      },
    ],
  },

  // MARK: Rotas especiais
  {
    path: '404',
    component: NotFound,
  },
  {
    path: '**',
    redirectTo: '404',
    pathMatch: 'full',
  },
];
